import React, {useMemo} from 'react';
import styled, {keyframes} from 'styled-components';

const FLOAT_ICONS = ['🃏', '❓', '🎯', '💡', '⭐', '🧩', '🧠', '🎲', '🏆', '✨', '🔮', '💫'];

export const TriviaBackground = () => {
    const icons = useMemo(() =>
        Array.from({length: 24}, (_, i) => ({
            icon: FLOAT_ICONS[i % FLOAT_ICONS.length],
            top: `${5 + Math.random() * 85}%`,
            left: `${2 + Math.random() * 90}%`,
            delay: `${Math.random() * 5}s`,
            duration: `${4 + Math.random() * 4}s`,
            size: `${16 + Math.random() * 14}px`,
        })), []);

    const bubbles = useMemo(() =>
        Array.from({length: 30}, () => ({
            left: `${Math.random() * 100}%`,
            s: 8 + Math.random() * 22,
            delay: `${-(Math.random() * 16)}s`,
            duration: `${8 + Math.random() * 10}s`,
            opacity: 0.15 + Math.random() * 0.25,
        })), []);

    return (
        <>
            {icons.map((f, i) => (
                <FloatingIcon key={`i${i}`} style={{
                    top: f.top,
                    left: f.left,
                    animationDelay: f.delay,
                    animationDuration: f.duration,
                    fontSize: f.size,
                }}>{f.icon}</FloatingIcon>
            ))}
            {bubbles.map((b, i) => (
                <Bubble key={`b${i}`} style={{
                    left: b.left,
                    width: b.s,
                    height: b.s,
                    animationDelay: b.delay,
                    '--bubble-op': b.opacity,
                    animationDuration: b.duration,
                }}/>
            ))}
        </>
    );
};

const floatIcon = keyframes`
    0%, 100% { transform: translateY(0) rotate(0deg); }
    50% { transform: translateY(-18px) rotate(8deg); }
`;

const FloatingIcon = styled.span`
    position: fixed;
    animation: ${floatIcon} 5s ease-in-out infinite;
    opacity: 0.25;
    pointer-events: none;
    z-index: 0;
`;

const bubbleRise = keyframes`
    0% { transform: translateY(0) translateX(0); }
    25% { transform: translateY(-25vh) translateX(8px); }
    50% { transform: translateY(-50vh) translateX(-6px); }
    75% { transform: translateY(-75vh) translateX(10px); }
    100% { transform: translateY(-110vh) translateX(0); }
`;

const Bubble = styled.div`
    position: fixed;
    bottom: -30px;
    border-radius: 50%;
    background: radial-gradient(circle at 30% 25%, rgba(200, 180, 255, 0.5) 0%, rgba(139, 92, 246, 0.35) 40%, rgba(59, 130, 246, 0.15) 100%);
    border: 1px solid rgba(180, 160, 255, 0.3);
    box-shadow: inset -2px -2px 4px rgba(59, 130, 246, 0.15), inset 2px 2px 4px rgba(255, 255, 255, 0.15);
    opacity: var(--bubble-op, 0.15);
    animation: ${bubbleRise} 12s linear infinite;
    pointer-events: none;
    z-index: 0;
`;
